<template>
	<div class="home">
		<!-- 分类 -->
		<div class="classify">
			<div class="classify-left">
				<h3>{{teacher.name}}</h3>
				<div class="classify-con" v-for="item in teacher.cate" :key="item.id">
					<div class="classify-a">{{item.name}}</div>
					<div class="classify-b">
						<a @click="openList(item.id)">全部</a>
						<a v-for="item in item.cate" :key="item.id" @click="openList(item.id)">{{item.name}}</a>
					</div>
				</div>
			</div>
			<div class="classify-right">
				<div class="classify-right-top">
					<h3>{{cause.name}}</h3>
					<div class="classify-con">
						<div class="classify-a">类别</div>
						<div class="classify-b">
							<a @click="openList(cause.id)">全部</a>
							<a v-for="(item,index) in cause.cate" @click="openList(item.id)">{{item.name}}</a>
						</div>
					</div>
				</div>
				<div style="height:20px;background:#f9f9f9"></div>
				<div class="classify-right-bottom">
					<h3>{{recruit.name}}</h3>
					<div class="classify-con">
						<div class="classify-a">类别</div>
						<div class="classify-b">
							<a @click="openList(recruit.id)">全部</a>
							<a v-for="(item,index) in recruit.cate" @click="openList(item.id)">{{item.name}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 宣传图 -->
		<div class="demo-image__placeholder">
			<div class="block">
				<el-image :src="src"></el-image>
			</div>
		</div>

		<!-- 推荐试题 -->
		<div class="test">
			<h3>推荐试题</h3>
			<router-link :to="{path:'/list',query:{tid:activeName}}" class="test-more">MORE+</router-link>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane :label="teacher.name" name="2">
					<div class="test-con">
						<p>热点试题</p>
						<dl v-for="(item,index) in testHot" :key="index">
							<dt>{{item.name}}</dt>
							<dd>
								<span v-if="item.price<=0">免费</span>
								<span v-else>{{item.price}}</span>
								<a @click="openAnswer(item.id)">立即答题</a>
							</dd>
						</dl>
					</div>
					<div class="test-con">
						<p>最新试题</p>
						<dl v-for="(item,index) in testNew" :key="index">
							<dt>{{item.name}}</dt>
							<dd>
								<span v-if="item.price<=0">免费</span>
								<span v-else>{{item.price}}</span>
								<a @click="openAnswer(item.id)">立即答题</a>
							</dd>
						</dl>
					</div>
					<div class="test-nav">
						<a v-for="(item,index) in testNav" :key="index" @click="openNavList(index,item.id)">
							<img :src="szUrl+item.image" :alt="item.name" />
							<p>{{item.name}}</p>
						</a>
						<router-link to>
							<img src="/images/nav_7.png" :alt="customReport" />
							<p>{{customReport}}</p>
						</router-link>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="cause.name" name="4">
					<div class="test-con">
						<p>热点试题</p>
						<dl v-for="(item,index) in testHot" :key="index">
							<dt>{{item.name}}</dt>
							<dd>
								<span v-if="item.price<=0">免费</span>
								<span v-else>{{item.price}}</span>
								<a @click="openAnswer(item.id)">立即答题</a>
							</dd>
						</dl>
					</div>
					<div class="test-con">
						<p>最新试题</p>
						<dl v-for="(item,index) in testNew" :key="index">
							<dt>{{item.name}}</dt>
							<dd>
								<span v-if="item.price<=0">免费</span>
								<span v-else>{{item.price}}</span>
								<a @click="openAnswer(item.id)">立即答题</a>
							</dd>
						</dl>
					</div>
					<div class="test-nav">
						<a v-for="(item,index) in testNav" :key="index" @click="openNavList(index,item.id)">
							<img :src="szUrl+item.image" :alt="item.name" />
							<p>{{item.name}}</p>
						</a>
						<router-link to>
							<img src="/images/nav_7.png" :alt="customReport" />
							<p>{{customReport}}</p>
						</router-link>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="recruit.name" name="3">
					<div class="test-con">
						<p>热点试题</p>
						<dl v-for="(item,index) in testHot" :key="index">
							<dt>{{item.name}}</dt>
							<dd>
								<span v-if="item.price<=0">免费</span>
								<span v-else>{{item.price}}</span>
								<a @click="openAnswer(item.id)">立即答题</a>
							</dd>
						</dl>
					</div>
					<div class="test-con">
						<p>最新试题</p>
						<dl v-for="(item,index) in testNew" :key="index">
							<dt>{{item.name}}</dt>
							<dd>
								<span v-if="item.price<=0">免费</span>
								<span v-else>{{item.price}}</span>
								<a @click="openAnswer(item.id)">立即答题</a>
							</dd>
						</dl>
					</div>
					<div class="test-nav">
						<a v-for="(item,index) in testNav" :key="index" @click="openNavList(index,item.id)">
							<img :src="szUrl+item.image" :alt="item.name" />
							<p>{{item.name}}</p>
						</a>
						<router-link to>
							<img src="/images/nav_7.png" :alt="customReport" />
							<p>{{customReport}}</p>
						</router-link>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				//教师资格证 2
				teacher: [],
				//事业单位 4
				cause: [],
				//教师公招 3
				recruit: [],
				testHot: [],
				testNew: [],
				testNav: [],
				src: "/images/6.png",
				activeName: "2",
				cate: [],
				customReport: "用户报告",
			};
		},
		methods: {
			handleClick() {
				var param = { tid: this.activeName };
				this.$post("getHotChapter", param).then((res) => {
					this.testHot = res.data;
				});
				this.$post("getNewChapter", param).then((res) => {
					this.testNew = res.data;
				});
				this.$post("getTypeList").then((res) => {
					this.testNav = res.data;
				});
			},
			// 获取顶部分类数据
			getTopCateData() {
				this.$post("getTopCate").then((res) => {
					this.teacher = res.data[0];
					this.cause = res.data[2];
					this.recruit = res.data[1];
				});
			},
			openList(id) {
				var id = id;
				this.$router.push({ path: "/list", query: { tid: id } });
			},
			//立即答题
			openAnswer(qid) {
				this.$router.push({ path: "/answer", query: { qid: qid } });
			},
			//专项跳转
			openNavList(index, mid) {
				this.$router.push({
					path: "/list",
					name: "List",
					query: {
						tid: this.activeName,
						mid: mid,
					},
					params: {
						active: index,
					},
				});
			},
		},
		created() {
			this.getTopCateData();
			this.handleClick();
		},
	};
</script>

<style>
	.classify {
		display: flex;
		justify-content: space-between;
	}
	.classify-left {
		background: #fff;
		width: 540px;
		padding: 25px;
	}
	.classify h3 {
		color: #333;
		position: relative;
		padding: 0 0 25px 20px;
		border-bottom: 1px solid #f3f3f3;
	}
	.classify h3::before {
		content: "";
		display: block;
		width: 4px;
		height: 18px;
		background-color:#e60012;
		position: absolute;
		left: 0;
		top: 4px;
	}
	.classify-con {
		display: flex;
		margin-top: 20px;
	}
	.classify-con:nth-child(3) .classify-a {
		background: url("/images/2.png") left 20px center no-repeat #fef2f3;
		background-size: auto 50px;
		color: #fd8485;
	}
	.classify-con:nth-child(4) .classify-a {
		background: url("/images/3.png") left 20px center no-repeat #fef4e7;
		background-size: auto 50px;
		color: #ffbc60;
	}
	.classify-con:nth-child(5) .classify-a {
		background: url("/images/4.png") left 20px center no-repeat #e9f8ff;
		background-size: auto 50px;
		color:#e60012;
	}
	.classify-a {
		width: 180px;
		min-height: 74px;
		background: url("/images/1.png") left 20px center no-repeat #fff3ee;
		background-size: auto 50px;
		margin-right: 10px;
		display: flex;
		align-items: center;
		font-size: 16px;
		color: #ff9058;
		text-indent: 80px;
	}
	.classify-b {
		flex: 1;
		display: flex;
		flex-wrap: wrap;
	}
	.classify-b a {
		padding: 0 10px;
		/* flex: 0 0 0; */
		margin-top: 5px;
		background: url("/images/line.png") right top 6px no-repeat;
		background-size: 1px 12px;
	}
	.classify-b a:hover {
		color:#e60012;
	}
	.classify-b a:last-child {
		background: none;
	}
	.classify-right {
		background: #fff;
		width: 590px;
		/* padding: 25px 0; */
	}
	.classify-right .classify-right-top,
	.classify-right .classify-right-bottom {
		padding: 25px;
	}
	.classify-right .classify-con .classify-a {
		background: url("/images/5.png") left 20px center no-repeat #f3f6ff;
		background-size: auto 50px;
		color: #7e97f0;
	}
	.demo-image__placeholder {
		margin: 30px auto;
	}
	.test {
		position: relative;
		background-color: #fff;
		padding: 0 30px;
	}
	.test h3 {
		position: absolute;
		left: 30px;
		color: #333;
		top: 25px;
		padding-left: 20px;
	}
	.test h3::before {
		content: "";
		display: block;
		width: 4px;
		height: 18px;
		background-color:#e60012;
		position: absolute;
		left: 0;
		top: 4px;
	}
	.test .el-tabs__header {
		padding-left: 120px;
		border-bottom: 1px solid #f3f3f3;
	}
	.test .el-tabs__nav-wrap::after {
		display: none;
	}
	.test .el-tabs__item {
		padding: 25px 20px;
		color: #999;
		height: auto;
		line-height: 24px;
	}
	.test .el-tabs__active-bar {
		background: url("/images/icon_1.png") center no-repeat;
		height: 8px;
	}
	.test-more {
		position: absolute;
		right: 30px;
		top: 25px;
		font-size: 16px;
		color: #ccc;
		z-index: 200;
	}
	.test-more:hover {
		color:#e60012;
	}
	.el-tab-pane {
		display: flex;
		flex-flow: nowrap;
	}
	.test-con {
		width: 360px;
		margin-right: 60px;
	}
	.test-con p {
		font-size: 16px;
		color: #333;
		padding-top: 10px;
	}
	.test-con dl {
		padding: 15px 0;
		border-bottom: 1px solid #f3f3f3;
		color: #666;
	}
	.test-con dd {
		background: url("/images/icon_2.png") left center no-repeat;
		background-size: auto 16px;
		padding-left: 25px;
		color: #999;
		margin-top: 5px;
	}
	.test-con dd a {
		float: right;
		color: #999;
	}
	.test-con dl:hover a {
		color:#e60012;
	}
	.test-nav {
		width: 292px;
		display: flex;
		flex-flow: wrap;
		padding-top: 10px;
		margin-left: 8px;
	}
	.test-nav a {
		display: block;
		width: 64px;
		margin: 0 0 50px 50px;
		text-align: center;
	}
	.test-nav a:nth-child(3n + 1) {
		margin: 0 0 50px 0;
	}
	.test-nav p {
		margin-top: 10px;
		color: #333;
	}
</style>
